import React from 'react';
import { Layout, Result, Button } from 'antd';
import { Section } from '../../components/section/Section';
import { Link } from '@nackle/biw-web-router';
import './styles.less';

const GeneralErrorView = ( { title, message, route, buttonText, status = '404' } ) => {

    return (
        <Layout className="error-page">
            <Layout.Content>
                <Section className="error-page-body">
                    <Result
                        status={ status }
                        title={ title }
                        subTitle={ message }
                        extra={ route && buttonText ?
                            <Link to={ route }>
                                <Button type="primary">
                                    { buttonText }
                                </Button>
                            </Link>
                            : <></>
                        }
                    />
                </Section>
            </Layout.Content>
        </Layout>
    );
};

export default GeneralErrorView;